import { Component } from '@angular/core';
import { NavController, ViewController, App, Events } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { LocationsProvider } from '../../providers/locations/locations';
import { CoLocationComponent } from '../co-location/co-location';
import { AppState } from '../../config/state';
import { TimeoutFunctionsProvider } from '../../providers/timeout-functions/timeout-functions';

/**
 * Generated class for the CoMapComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-map',
  templateUrl: 'co-map.html'
})
export class CoMapComponent {
  allLocations: any;
  location: any = null;
  lastMarkerOpen: any;

  constructor(public navCtrl: NavController, public viewCtrl: ViewController, public config: ConfigProvider, public app: App, public locationsProvider: LocationsProvider, private state : AppState, private events : Events, private timeout : TimeoutFunctionsProvider) {
    this.events.subscribe('timeoutCalled', ()=> this.timeout.doLogoutFunctions(this));
    this.locationsProvider.getLocations().then(location => {
      this.allLocations = location;
    });
  }

  setCurrentLocation(locationInfo: any) {
    this.location = locationInfo;
  }

  goToLocation(location: any) {
    this.config.load(this.state.appId).then(cfg => {
      this.viewCtrl.dismiss().then(() => {
        this.app.getRootNav().push(CoLocationComponent, { location: location, showNavbar: true });
      }).catch(err=>{});
    });
  }

  // mapClicked(i: any) {
  //   let marker = document.getElementById(`marker${i}`);

  //   if(!this.lastMarkerOpen) {
  //     this.lastMarkerOpen = marker;
  //     return;
  //   }

  //   if (this.lastMarkerOpen != marker) {
  //     this.lastMarkerOpen.setAttribute("[isOpen]", true);
  //   }
  //   this.lastMarkerOpen = marker;
  // }

}



// WEBPACK FOOTER //
// ./src/components/co-map/co-map.ts